export const AppPages = {
  HOME: '/home',
  DRIVERS: '/drivers',
  VEHICLES: '/vehicles',
  ADDITIONALS: '/additionals',
  PERSON: '/person',
  SUCCESS: '/success',
  PAYMENT: '/payment',
  RESERVATION: '/reservation',
};
